"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConstantSchema = exports.ConstantValue = void 0;
const codegen_1 = require("@azure-tools/codegen");
const schema_1 = require("../schema");
const schema_type_1 = require("../schema-type");
class ConstantValue extends codegen_1.Initializer {
    constructor(value, objectInitializer) {
        super();
        this.value = value;
        this.apply(objectInitializer);
    }
}
exports.ConstantValue = ConstantValue;
class ConstantSchema extends schema_1.Schema {
    constructor(name, description, objectInitializer) {
        super(name, description, schema_type_1.SchemaType.Constant);
        this.apply(objectInitializer);
    }
}
exports.ConstantSchema = ConstantSchema;
//# sourceMappingURL=constant.js.map